// client/src/routes/app/notifications.tsx — SCR-NOTIF-001 · ALR-004 (04 §8.12).
//
// Replaces UI-003's `PlaceholderScreen`, which named this item as its owner.
//
// The route owns the URL state and nothing else: `validateSearch` runs the §9.2.3 schema and
// the screen reads it back typed, so „doar necitite, pagina 2" survives a refresh and Back is a
// filter-undo.
//
// THERE IS NO PERMISSION GUARD, and that is deliberate rather than an omission. 04 §6.2 gates
// this nav entry on „(any)", and `GET /api/v1/notifications` is behind `Notifications.Read`,
// which 03 §17.1 grants to every seeded role that enters this shell — the audience 01
// BR-NOTIF-08 scopes an organization's notifications to. A `RequirePermission` here would
// mirror a gate that excludes nobody; the API is still the enforcement (02 §6.4, 04 §9.2.2).

import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { NotificationInbox } from '@/features/notifications/NotificationInbox';
import { notificationSearchSchema, type NotificationSearch } from '@/features/notifications/search';

export const Route = createFileRoute('/app/notifications')({
  validateSearch: notificationSearchSchema,
  component: NotificationsScreen,
});

function NotificationsScreen() {
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });

  return (
    <NotificationInbox
      search={search}
      onSearchChange={(next: (previous: NotificationSearch) => NotificationSearch) => {
        void navigate({ search: next });
      }}
    />
  );
}
